import * as React from 'react';

// app context
const AppContext = React.createContext<any>(null);

// snackbar context
const SnackbarContext = React.createContext<any>(null);

export {AppContext, SnackbarContext};